import { environnement } from "configs/environnement";
import api from "./api";
import {
  IEcodimeClassResponseDTO,
  ISaveEcodimeClassDTO,
  IUpdateEcodimeClassDTO,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/ecodime-classes`;

export const EcodimeClassService = {
  getAll: async (page: number, size: number) => {
    const response = await api.get<IEcodimeClassResponseDTO[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
          query: "",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  getAllSimple: async (): Promise<IEcodimeClassResponseDTO[]> => {
    const response = await api.get<IEcodimeClassResponseDTO[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: 0,
          size: 1000,
          sort: "name,asc",
        },
      },
    );
    return response.data;
  },

  create: async (
    ecodimeClass: ISaveEcodimeClassDTO,
  ): Promise<IEcodimeClassResponseDTO> => {
    const response = await api.post<IEcodimeClassResponseDTO>(
      `${BASE_URL}`,
      ecodimeClass,
    );
    return response.data;
  },

  update: async (
    ecodimeClass: IUpdateEcodimeClassDTO,
  ): Promise<IEcodimeClassResponseDTO> => {
    const response = await api.put<IEcodimeClassResponseDTO>(
      `${BASE_URL}`,
      ecodimeClass,
    );
    return response.data;
  },

  getById: async (id: number): Promise<IEcodimeClassResponseDTO> => {
    const response = await api.get<IEcodimeClassResponseDTO>(
      `${BASE_URL}/${id}`,
    );
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IEcodimeClassResponseDTO[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
